module.exports = {"id":"225953","name":"Steven Bergwijn","rating":"74","photo":"./data/images/photos/3/225953.png","club":{"name":"PSV","logo":"./data/images/clubs/PSV.png"},"positions":["AG","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StevenBergwijn0.json
// module id = 4036
// module chunks = 0